module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-15.8ac93bd6.png";